import { useLingui } from '@lingui/react/macro';
import { useRouter } from '@tanstack/react-router';
import { Button } from '@utima/ui';
import { Trash, Save, ArrowLeft } from 'lucide-react';
import { memo, type ReactNode, type SyntheticEvent } from 'react';

export type ActionBarProps = {
  showDelete?: boolean;
  loading?: boolean;
  onDelete?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  extraActions?: ReactNode;
};

export const ActionBar = memo(function ActionBar({
  showDelete = true,
  loading,
  onDelete,
  extraActions,
}: ActionBarProps) {
  const { t } = useLingui();
  const router = useRouter();

  return (
    <div
      className='sticky bottom-6 z-10 mt-12 flex w-full justify-between rounded-xl border bg-white p-2'
      data-testid='action-bar'
    >
      <Button
        data-cta='admin-action-bar-discard-changes'
        variant='secondary'
        icon={<ArrowLeft size={18} />}
        onClick={() => router.history.go(-1)}
      >
        <span className='hidden sm:inline'>{t`Discard changes`}</span>
      </Button>
      <div className='flex gap-x-3'>
        {extraActions}
        {showDelete && onDelete && (
          <Button
            data-cta='admin-action-bar-delete'
            onClick={onDelete}
            disabled={loading}
            type='button'
            variant='danger'
            icon={<Trash size={18} />}
          >
            <span className='hidden sm:inline'>{t`Delete`}</span>
          </Button>
        )}
        <Button
          data-cta='admin-action-bar-save'
          loading={loading}
          disabled={loading}
          variant='success'
          type='submit'
          icon={<Save size={18} />}
        >
          <span className='hidden sm:inline'>{t`Save`}</span>
        </Button>
      </div>
    </div>
  );
});
